import http from '../http'
import type { ApiResponse } from '../types'
import type { LoginRequest, User } from '@/types/auth'

// 登录响应数据
export interface LoginResponseData {
  user: User
  accessToken: string
  refreshToken: string
}

// 认证相关API
export const authApi = {
  // 用户登录
  async login(loginData: LoginRequest): Promise<ApiResponse<LoginResponseData>> {
    return http.post('/api/auth/login', loginData)
  },

  // 获取用户信息
  async getProfile(): Promise<ApiResponse<User>> {
    return http.get('/api/auth/profile')
  },

  // 刷新令牌
  async refreshToken(): Promise<ApiResponse<LoginResponseData>> {
    return http.post('/api/auth/refresh')
  },

  // 退出登录
  async logout(): Promise<ApiResponse> {
    return http.post('/api/auth/logout')
  },

  // 修改密码
  async changePassword(data: { currentPassword: string; newPassword: string }): Promise<ApiResponse> {
    return http.post('/api/auth/change-password', data)
  },
}
